import { useEffect } from 'react';

/**
 * Hook per impostare il titolo della pagina
 * @param {string} title - Il titolo specifico della pagina
 * @param {boolean} appendSiteName - Se aggiungere "| IlTuoAmaro.it" alla fine
 */
export const usePageTitle = (title, appendSiteName = true) => {
  useEffect(() => {
    const siteName = 'IlTuoAmaro.it';
    const fullTitle = appendSiteName ? `${title} | ${siteName}` : title;
    
    console.log('🔖 Cambio titolo:', fullTitle);
    document.title = fullTitle;
  }, [title, appendSiteName]);
};
